// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1sKlK","type":"styles_type__3kjrY","choices":"styles_choices__23r9S"};